module.exports = __webpack_public_path__ + "static/media/bg.ad9dce3b.svg";